import * as React from "react";

function SvgSavio(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g transform="translate(254.958 255.023) scale(15.62642)">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M23.11 55.78L1.69 43.41A3.39 3.39 0 010 40.48V15.75a3.39 3.39 0 011.69-2.94L23.11.45a3.39 3.39 0 013.39 0l21.41 12.37a3.39 3.39 0 011.69 2.94v24.72a3.39 3.39 0 01-1.69 2.94L26.5 55.78a3.39 3.39 0 01-3.39 0z"
        />
      </g>
      <g fill="#fff" transform="matrix(6.04267 0 0 6.04267 343.759 394.131)">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M87.39 8.13c-.6-.25-2.21-.65-4.06 1.17L65.74 26.49a6.07 6.07 0 01-4.63 1.36A69.32 69.32 0 0050 26.49a69.29 69.29 0 00-11.11 1.36 6 6 0 01-4.63-1.36L16.68 9.3c-1.86-1.82-3.46-1.42-4.06-1.17s-2 1.12-2 3.72v39a12.27 12.27 0 003.28 7.85l30.6 30.16 2.06 2a4.47 4.47 0 003.19 1.24 6.29 6.29 0 004.35-1.87l32-31.57a12.27 12.27 0 003.28-7.85v-39c.01-2.55-1.38-3.42-1.99-3.68zm-72.82 4.65L31.5 29.32a9.88 9.88 0 008.19 2.41A66.36 66.36 0 0150 30.45a66.53 66.53 0 0110.31 1.28 9.89 9.89 0 008.19-2.41l16.93-16.54v38a7 7 0 01-.49 2.3H68.86a2 2 0 00-1.7 1L56 72.56H44.22l-11-18.49a2 2 0 00-1.7-1H15.06a7 7 0 01-.49-2.3zm3.35 44.29h12.46l17.76 29.78-.87-.85zm34.45 29.3L70 57.06h12.09z"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M18.99 24.09v15.18l10.64-5.5-10.64-9.68zM81.01 24.09l-10.64 9.68 10.64 5.5V24.09z"
        />
        <circle
          xmlns="http://www.w3.org/2000/svg"
          cx={38.95}
          cy={45.46}
          r={2.61}
        />
        <circle
          xmlns="http://www.w3.org/2000/svg"
          cx={61.05}
          cy={45.46}
          r={2.61}
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSavio);
